import * as React from 'react';

import GridCol from '@Components/layout/Grid/GridCol';
import GridRow from '@Components/layout/Grid/GridRow';
import Paper, { PaperWidth } from '@Components/Paper';
import PaperBody, { PaperBodySpacing } from '@Components/PaperBody';
import { useTranslations } from '@Hooks/useTranslations';
import SectionTitle from '@Routes/static/LandingPage/SectionTitle';
import { getTranslationValue, MessageKeysWithoutParams } from '@Utils/translation';

import styles from './PageSection.module.scss';

export interface PageSectionProps {
  title: MessageKeysWithoutParams | string;
  spacing?: PaperBodySpacing;
  children?: React.ReactNode;
}

const PageSection: React.FunctionComponent<PageSectionProps> = ({ children, title, spacing = PaperBodySpacing.m }) => {
  const t = useTranslations();
  const translatedTitle = getTranslationValue({ value: title, t });

  return (
    <Paper width={PaperWidth.full}>
      <PaperBody spacing={spacing}>
        <GridRow>
          <GridCol size={12} className={styles.sectionTitleWrapper}>
            <SectionTitle msg={translatedTitle} />
          </GridCol>
        </GridRow>
        <GridRow>
          <GridCol size={12}>{children}</GridCol>
        </GridRow>
      </PaperBody>
    </Paper>
  );
};

export default PageSection;
